import React from "react"

import ConditionTypeSelector from "../../../proto/render/condition/condition-type-selector"
import {ConditionType} from "../../../../model2/conditions/condition-types"
import {FieldConditionFormProps} from "../../../render/condition/@types"
import Filter from "../../../../manager/filters/manager/filter"
import SelectMultiGenericNew from "../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import FieldTaskStoryPoints from "../../../system/task/story-points/story-points"

// const debug = "FieldTaskStoryPoints_ConditionForm"
const debug = false

export default function FieldTaskStoryPoints_ConditionForm(props:FieldConditionFormProps) {

    const filter = props.condition as Filter
    const field = filter.field as FieldTaskStoryPoints

    const onChangeType = (conditionType: ConditionType) => {
        props.condition.type = conditionType
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const onChangeValue = (value: any) => {
        props.condition.value = value
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    // patch to fix old conditions where value is number
    const values = Array.isArray(props.condition.value) ? props.condition.value : []

    return (
        <>
            <ConditionTypeSelector field    = {props.field}
                                   value    = {props.condition.type}
                                   onChange = {onChangeType}/>

            <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                   options                          = {field.filterGetAllOptions()}
                                   values                           = {values}
                                   popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                   isSearchable                     = {true}
                                   onChange                         = {onChangeValue}/>
        </>
    )
}
